<template>
  <video
    v-if="videoSrc"
    :src="videoSrc"
    controls
    preload="auto"
    tabindex="-1">
    <source
      :src="videoSrc"
      type="video/mp4"
    >
    <p>To view this video please enable JavaScript, and consider upgrading to a web browser that <a
      hidden="hidden"
      href=""
      target="_blank">supports HTML5 video</a></p>
  </video>
</template>

<script>
export default {
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    videoSrc () {
      if (!this.store.state.recast.source) return false

      return this.store.state.recast.source
    }
  }
}
</script>

<style lang="scss" scoped>
video {
  width: 100%;
}
</style>
